var _circle, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyAccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13.5,
    r: 12.625,
    fill: "white",
    stroke: "url(#paint0_linear_9815_7275)",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 9.41667C15.6555 9.41667 15.9167 9.1555 15.9167 8.83333C15.9167 8.51117 15.6555 8.25 15.3333 8.25C15.0112 8.25 14.75 8.51117 14.75 8.83333C14.75 9.1555 15.0112 9.41667 15.3333 9.41667Z",
    stroke: "#181A49",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.501 17.5833L17.0843 13.5L13.6602 14.0483",
    stroke: "#181A49",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91797 11.167L10.668 9.41699L13.8763 11.167L12.5871 12.9753",
    stroke: "#181A49",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47206 14.9463C8.36122 15.2846 8.31456 15.6463 8.33789 16.0196C8.36239 16.4019 8.46194 16.7756 8.63086 17.1194C8.79979 17.4632 9.03478 17.7703 9.32241 18.0233C9.61004 18.2762 9.94469 18.4701 10.3072 18.5937C10.6698 18.7173 11.0531 18.7683 11.4354 18.7438C11.8146 18.7205 12.1646 18.6271 12.4854 18.4755",
    stroke: "#181A49",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.029 16.7205C14.1398 16.3821 14.1865 16.0205 14.1631 15.6471C14.1386 15.2649 14.0391 14.8912 13.8702 14.5474C13.7012 14.2036 13.4662 13.8965 13.1786 13.6435C12.891 13.3905 12.5563 13.1967 12.1938 13.0731C11.8312 12.9495 11.4479 12.8984 11.0656 12.923C10.6865 12.9463 10.3365 13.0396 10.0156 13.1913",
    stroke: "#181A49",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9815_7275",
    x1: 17.2829,
    y1: 16.6898,
    x2: -6.64684,
    y2: 18.2914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDDFC",
    stopOpacity: 0.28
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyAccessIcon);
export default __webpack_public_path__ + "static/media/cy-access-icon.6be15b125f9ab94764732a7b6ac08e97.svg";
export { ForwardRef as ReactComponent };